module.exports = "fragment MinimalContactFragment on Contact {\n  __typename\n  id\n  firstName\n  lastName\n}\n"